import { Company, Contact, Shareholder } from '@app/core/stingray-api/models';
import { ApplicantView } from './applicant-view';
import { ShareholderView } from './shareholder-view';
import { UntypedFormGroup } from '@angular/forms';
import { getFormGroupValue } from '@app/validators/form-group-tools';

export class CompanyApplicantView extends ApplicantView {
  company: Company;

  shareholders: Shareholder[] = [];
  shareholderViews: ShareholderView[] = [];

  constructor() {
    super();
    this.type = 'Company';
  }


  isValid(): boolean {
    // return this.getContact() && this.shareholders.length > 0 && this.form.valid;
    return this.getContact() && this.form.valid;
  }

  getContact(): Contact {
    return getFormGroupValue(this.form.get('contact') as UntypedFormGroup) as Contact;
  }

}
